import axios from "axios";
import { createFilterState, createPaginatedState, createPaginatedStateWithSummary, handlePaginatedResponse } from '../helpers/paginationState';

export const  state = {
    store_stock:[],
    store_pdts:[],
    store_cart:[],
    total_store_cart:"",
    save_status:false,
    purchaseId:'',
    price_change:[],
    filter_status:false,
    stock_movements: [],
    price_changes_paginated: createPaginatedState(),
    current_price_changes_filters: createFilterState({
        datefrom: '',
        dateto: '',
        product: ''
    }),
    store_stock_paginated: createPaginatedStateWithSummary(50, {
        total_selling_price_value: 0,
        total_buying_price_value: 0,
    }),
    current_store_stock_filters: createFilterState({
        product: '',
        category: ''
    }, 50),
    stores:[]    
};
export const getters = {
    StoreStock: state => state.store_stock.data,
    StorePdts: state => state.store_pdts.data,
    TotalStoreCart: state => state.total_store_cart,
    StoreCart: state => state.store_cart.data,
    SaveStatus: state => state.save_status,
    PurchaseId: state => state.purchaseId,
    FilterStatus: state => state.filter_status,
    PriceChange: state => state.price_change.data,
    StockMovement: state => state.stock_movements.data,

    StoreStockPaginated: state => state.store_stock_paginated.data,
    StoreStockPagination: state => state.store_stock_paginated.meta,
    IsStoreStockServerPaginated: state => state.store_stock_paginated.isServerPaginated,
    StoreStockSummary: state => state.store_stock_paginated.summary,
    CurrentStoreStockFilters: state => state.current_store_stock_filters,
    Stores: state => state.stores,

    PriceChangePaginated: state => state.price_changes_paginated.data,
    PriceChangePagination: state => state.price_changes_paginated.meta,
    IsPriceChangeServerPaginated: state => state.price_changes_paginated.isServerPaginated,
    CurrentPriceChangesFilters: state => state.current_price_changes_filters,
};
export const mutations= {

    SET_STORE_STOCK(state,newValue){
        state.store_stock = newValue
    },
    SET_STORE_PDTS(state,newValue){
        state.store_pdts = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_STORE_CART(state, newValue) {
        state.store_cart = newValue
    },
    SET_TOTAL_STORE_CART(state, newValue) {
        state.total_store_cart = newValue
    },
    SET_PURCHASES_ID(state, newValue) {
        state.purchaseId = newValue
    },
    SET_PRICE_CHANGE(state, newValue) {
        state.price_change = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_STOCK_MOVEMENTS(state, newValue) {
        state.stock_movements = newValue
    },
    SET_STORE_STOCK_PAGINATED(state, response) {
        handlePaginatedResponse(state.store_stock_paginated, response);
    },
    UPDATE_CURRENT_STORE_STOCK_FILTERS(state, filters) {
        state.current_store_stock_filters = { ...state.current_store_stock_filters, ...filters };
    },
    SET_STORES(state, newValue) {
        state.stores = newValue
    },
    SET_PRICE_CHANGES_PAGINATED(state, response) {
        handlePaginatedResponse(state.price_changes_paginated, response);
    },
    UPDATE_CURRENT_PRICE_CHANGES_FILTERS(state, filters) {
        state.current_price_changes_filters = { ...state.current_price_changes_filters, ...filters };
    },
};
export const actions={

    // Process purchase and print
    savePurchasePrint({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`store_purchases`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            if (response.status==200){
                let message = { 'msg': "Purchase Recorded successfully" }
                dispatch('notification/success', message, { root: true })
                commit('SET_PURCHASES_ID', response.data.id)
            }else if(response.status==201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process purchase and exit
    savePurchaseExit({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`store_purchases`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            if (response.status==200){
                let message = { 'msg': "Purchase Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add products to store cart
    addToStoreCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('store_purchase_cart', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            if (response.status != 200) {
                if (response.data.message) {
                    let message = { 'msg': response.data.message }
                    dispatch('notification/error', message, { root: true })
                } else {
                    let message = { 'msg': "Failed to add to cart" }
                    dispatch('notification/error', message, { root: true })
                }
            }
        }).catch((error)=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add to cart: "+ (error.response?.data?.message || error.message) }
            dispatch('notification/error', message, { root: true })
        })
    },

    editStoreCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`store_purchase_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            if (response.status == 200) {
                let message = { 'msg': "Cart edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status != 200 && response.data.message) {
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            } else {
                let message = { 'msg': "Failed to edit cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch((error)=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit cart: "+ (error.response?.data?.message || error.message) }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteStoreCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`store_purchase_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchStoreCart')
            dispatch('fetchTotStoreCart')
            if (response.status==200){
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name+' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // remove expired stock
    removeExpired({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('mark_as_expired', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchExpiredStock')
            if (response.status==200){
                let message = { 'msg': "Product successfully marked as expired" }
                dispatch('notification/success', message, { root: true })
            }else if(response.status==201) {
                let message = { 'msg': "Operation was unsuccessful" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(()=>{
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to mark Product as Expired" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Store roconciliation
    addQty({ commit },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`reconcile/${payload.id}`, payload).then(() => {
            // dispatch('fetchStoreStock');
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
        })
    },

    SaveReconcile({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`save_reconcile`, { type: 1 }).then(() => {
            if (payload) {
                dispatch('fetchStoreStockData', payload);
            }
            let message = { 'msg': `Stock Reconciled successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Reconciling Stock" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editBPrice({ commit,dispatch },payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`updateStoreBPrice/${payload.id}`, payload).then(() => {
            dispatch('fetchStoreStockData', state.current_store_stock_filters);
            let message = { 'msg': `Buying Price Amount  updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Buying Price" }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchStoreCart({ commit }) {
        axios.get('store_purchase_cart').then(cart => {
            commit('SET_STORE_CART', cart.data)
        })
    },

    fetchTotStoreCart({ commit }) {
        axios.get('total_store_cart').then(total => {
            commit('SET_TOTAL_STORE_CART', total.data)
        })
    },

    fetchStoreStockData({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page || 1,
            per_page: payload.per_page || 50,
            store: payload.store || '',
            product: payload.product || '',
            category: payload.category || '',
            id: payload.id || ''
        };
        commit('UPDATE_CURRENT_STORE_STOCK_FILTERS', apiPayload);

        axios.post('store_stock', apiPayload)
            .then(response => {
                commit('SET_STORE_STOCK_PAGINATED', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_STORE_STOCK_PAGINATED', {
                    data: [],
                    meta: {},
                    summary: {
                        total_selling_price_value: 0,
                        total_buying_price_value: 0
                    }
                });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load store stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },

    fetchStoreStockDataSilent({ commit, dispatch }, payload) {
        const apiPayload = {
            page: payload?.page || 1,
            per_page: payload?.per_page || 50,
            store: payload?.store || '',
            product: payload?.product || '',
            category: payload?.category || ''
        };
        commit('UPDATE_CURRENT_STORE_STOCK_FILTERS', apiPayload);

        return axios.post('store_stock', apiPayload)
            .then(response => {
                commit('SET_STORE_STOCK_PAGINATED', response.data);
                return response.data;
            })
            .catch((error) => {
                commit('SET_STORE_STOCK_PAGINATED', {
                    data: [],
                    meta: {},
                    summary: {
                        total_selling_price_value: 0,
                        total_buying_price_value: 0
                    }
                });
                let errorMsg = 'Failed to load store stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
                throw error;
            });
    },

    fetchStoreStock({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post('store_stock', payload).then(total => {
            commit('SET_STORE_STOCK', total.data)
            commit('SET_FILTER_STATUS', false)
        })
    },

    fetchStorePdts({ commit }) {
        axios.get(`store`).then(total => {
            commit('SET_STORE_PDTS', total.data)
        })
    },

    import_products({commit, dispatch}){
        commit('SET_SAVE_STATUS', true);
        axios.post('imports').then((res) => {
            if (res.data.status == 200) {
                let message = { 'msg': res.data.message }
                dispatch('notification/success', message, { root: true })
                commit('SET_SAVE_STATUS', false);
            }
            else if (res.data.status == 201) {
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })
                commit('SET_SAVE_STATUS', false);
            }
        })
        .catch(() => {
            let message = { 'msg': 'Importation failed, please try again later' }
            dispatch('notification/error', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        });
    },

    // Fetch Price Changes
    fetchPriceChanges({ commit }) {
        axios.get(`storeprice_change`).then(res => {
            commit('SET_PRICE_CHANGE', res.data)
        })
    },

    fetchPriceChangesData({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page || 1,
            per_page: payload.per_page || 50,
            datefrom: payload.datefrom || '',
            dateto: payload.dateto || '',
            product: payload.product || ''
        };
        commit('UPDATE_CURRENT_PRICE_CHANGES_FILTERS', apiPayload);

        const params = new URLSearchParams();
        Object.keys(apiPayload).forEach(key => {
            if (apiPayload[key] !== '' && apiPayload[key] !== 0) {
                params.append(key, apiPayload[key]);
            }
        });

        const queryString = params.toString();
        const apiUrl = queryString ? `storeprice_change?${queryString}` : 'storeprice_change';

        axios.get(apiUrl)
            .then(response => {
                commit('SET_PRICE_CHANGES_PAGINATED', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_PRICE_CHANGES_PAGINATED', { data: [], meta: {} });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load price changes.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },

    fetchStockMovements({ commit }, payload) {
        commit('SET_FILTER_STATUS', true)
        axios.post(`store_movement/${payload.id}`, payload).then(response => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_STOCK_MOVEMENTS', response.data)
        })
    },

    // Multiple stores
    fetchStores({ commit }) {
        commit('SET_FILTER_STATUS', true)
        axios.get('multiple_stores').then(total => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_STORES', total.data)
        })
    },

    addStore({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('multiple_stores', payload).then((response) => {
            if(response.status == 200){
                dispatch('fetchStores');
                let message = { 'msg': `Store ${payload.name} added successfully` }
                dispatch('notification/success', message, { root: true })
            }else if(response.status == 202){
                dispatch('fetchStores');
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }else{
                commit('SET_SAVE_STATUS', false)
                let message = { 'msg': "Error Adding Store" }
                dispatch('notification/error', message, { root: true })
            }            
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Store " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    editStore({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`multiple_stores/${payload.id}`, payload).then(() => {
            dispatch('fetchStores');
            let message = { 'msg': `Store ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Updating Store" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteStore({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`multiple_stores/${payload.id}`).then(() => {
            dispatch('fetchStores');
            let message = { 'msg': `Store ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in deleting Store" + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add store products
    addProducts({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('store', payload).then((response) => {
            if(response.status == 200){
                let message = { 'msg': `Product ${payload.name} added successfully` }
                dispatch('notification/success', message, { root: true })
            }else if(response.status == 202){
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }else{
                commit('SET_SAVE_STATUS', false)
                let message = { 'msg': "Error Adding Product" }
                dispatch('notification/error', message, { root: true })
            }            
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Product " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // edit store products
    editProducts({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`store/${payload.id}`, payload).then((response) => {
            if(response.status == 200){
                let message = { 'msg': `Product ${payload.name} updated successfully` }
                dispatch('notification/success', message, { root: true })
            }else if(response.status == 202){
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }else{
                commit('SET_SAVE_STATUS', false)
                let message = { 'msg': "Error Updating Product" }
                dispatch('notification/error', message, { root: true })
            }            
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Updating Product " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete store products
    deleteProducts({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`store/${payload.id}`).then((response) => {
            if(response.status == 200){
                let message = { 'msg': `Product ${payload.name} deleted successfully` }
                dispatch('notification/success', message, { root: true })
            }else if(response.status == 202){
                let message = { 'msg': response.data.message }
                dispatch('notification/error', message, { root: true })
            }else{
                commit('SET_SAVE_STATUS', false)
                let message = { 'msg': "Error Deleting Product" }
                dispatch('notification/error', message, { root: true })
            }            
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Deleting Product " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    importBranchStoreProducts({commit, dispatch}){
        commit('SET_SAVE_STATUS', true);
        axios.post('import_branchstore_products').then((res) => {
            if (res.data.status == 200) {
                let message = { 'msg': res.data.message }
                dispatch('notification/success', message, { root: true })
                commit('SET_SAVE_STATUS', false);
            }
            else if (res.data.status == 201) {
                let message = { 'msg': res.data.message }
                dispatch('notification/error', message, { root: true })
                commit('SET_SAVE_STATUS', false);
            }
        })
        .catch(() => {
            let message = { 'msg': 'Importation failed, please try again later' }
            dispatch('notification/error', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        });
    },

};


